import React, { useState, useEffect } from "react";
import InternationalizationContext from 'contexts/InternationalizationContext'
import { InternationalizationState } from 'services/shared/Internationalization'
import { isAtJgntUrl, isProductionEnvironment } from "services/shared/Environment";
import { useRouter } from "next/router";

function InternationalizationProvider({ children }) {

    const [internationalizationState, setInternationalizationState] = useState<InternationalizationState>({
      visitorIsFromIndia: false
    });

    useEffect(() => {
        fetch('/api/is-indian-ip').then(res => res.json()).then(visitorIsFromIndia => {
            setInternationalizationState({ visitorIsFromIndia })
        })
    }, [])

    const { asPath } = useRouter()

    useEffect(() => {
      const { visitorIsFromIndia } = internationalizationState;
      const redirectInProd = visitorIsFromIndia && !isAtJgntUrl();
      if (isProductionEnvironment() && redirectInProd) {
        window.location.href = `https://www.jgnt.co${asPath}`;
      }
    }, [internationalizationState, asPath]);

    return (
        <InternationalizationContext.Provider value={internationalizationState}>
            {children}
        </InternationalizationContext.Provider>
    )
}

export default InternationalizationProvider